import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/material.module';
import { PopupAndNotifService } from 'src/app/core/services/popup-and-notif.service';
import { RegistreService } from 'src/app/core/services/registre.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { ApConnectPost } from 'src/app/core/models/apconnectpost';
import { finalize } from 'rxjs';
import {
  APSCAN_LOGIN_ERROR_TITLE,
  apscanLoginErrorMessage,
  isApscanLoginSuccess,
} from 'src/app/core/services/apscan-login-rules';

interface ApscanLoginDialogData {
  currentUser: any;
}

@Component({
  selector: 'app-apscan-login-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MaterialModule],
  templateUrl: './apscan-login-dialog.component.html',
})
export class ApscanLoginDialogComponent {
  loginForm: FormGroup;
  loading = false;
  private currentUser: any;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ApscanLoginDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: ApscanLoginDialogData,
    private popupAndNotifService: PopupAndNotifService,
    private registreService: RegistreService,
    private helperService: HelperService,
    private authService: AuthService
  ) {
    this.currentUser = data?.currentUser ?? this.authService.currentUser();
    this.loginForm = this.fb.group({
      email: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
  }

  submit(): void {
    if (this.loading) {
      return;
    }

    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    const payload = new ApConnectPost();
    payload.ap_email = this.loginForm.value.email;
    payload.ap_password = this.loginForm.value.password;
    payload.slug_user = this.currentUser?.username ?? '';

    if (!payload.slug_user) {
      this.helperService.openSnackBar('Unable to determine the current user.', 'Close');
      return;
    }

    this.loading = true;
    this.dialogRef.disableClose = true;
    this.popupAndNotifService.showSpinner();

    this.registreService
      .apsolution_login(payload)
      .pipe(
        finalize(() => {
          this.loading = false;
          this.dialogRef.disableClose = false;
          this.popupAndNotifService.hideSpinner();
        })
      )
      .subscribe({
        next: (data) => {
          if (!isApscanLoginSuccess(data)) {
            this.popupAndNotifService.showNotification(
              apscanLoginErrorMessage(data),
              APSCAN_LOGIN_ERROR_TITLE,
              'error'
            );
            return;
          }

          this.authService.is_aptokenaccess = true;
          this.helperService.openSnackBar('You are connected to APSCAN', 'Close');
          this.dialogRef.close(true);
        },
        error: () => {
          this.popupAndNotifService.showNotification(
            'ArturPro could not reach the APScan login service. You are not connected to APScan; please try again in a few minutes.',
            APSCAN_LOGIN_ERROR_TITLE,
            'error'
          );
        },
      });
  }

  cancel(): void {
    if (this.loading) {
      return;
    }
    this.dialogRef.close(false);
  }
}

